import axios from 'axios'
import querystring from 'querystring'
import _ from 'lodash'

// initial state

const state = {
  details: null,
  searchResult: null,
  belts: null,
  beltMembers: []
}

// getters
const getters = {
  details: state => state.details,
  searchResult: state => state.searchResult,
  beltMembers: state => state.beltMembers,
  belts: state => _.reverse(state.belts),
  getBelt: state => id => _.find(state.belts, (o) => o.id === id),
  beltsPath: (state, getters, rootState, rootGetters) => rootGetters['config'].API.beltsPath,
  gfxPath: (state, getters, rootState, rootGetters) => rootGetters['config'].API.gfxPath
}

// actions
const actions = {
  search: function (context, searchString) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.searchMembers,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        searchString: searchString
      })
    )
    .then(
      (response) => {
        context.commit('SET_SEARCH', response.data.members)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getDetails: function (context, map) {
    context.commit('SET_DETAILS', null)
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getMemberDetailsByMap,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        map: map
      })
    )
    .then(
      (response) => {
        context.commit('SET_DETAILS', response.data.member)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getBelts: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getBelts,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_BELTS', response.data.belts)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getBeltMembers: function (context, id) {
    console.log('getBeltMembers')
    context.commit('SET_BELT_MEMBERS', [])
    console.log(context.rootGetters['config'].API.getMembersByBeltId)
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getMembersByBeltId,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        beltId: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_BELT_MEMBERS', response.data.members)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  }
}

// mutations
const mutations = {
  SET_SEARCH (state, data) {
    state.searchResult = data
    console.log('SET_SEARCH')
    console.log(state.searchResult)
  },
  SET_DETAILS (state, data) {
    state.details = data
    console.log('SET_DETAILS')
    console.log(state.details)
  },
  SET_BELTS (state, data) {
    state.belts = data
    console.log('SET_BELTS')
    console.log(state.belts)
  },
  SET_BELT_MEMBERS (state, data) {
    state.beltMembers = data
    console.log('SET_BELT_MEMBERS')
    console.log(state.beltMembers)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
